var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Platform } from "react-native";
import { call, put, takeLatest } from "redux-saga/effects";
import logger from "../../logger";
import * as assetApi from "../../reduxV2/assets/assets.api";
import * as brokerActionsV2 from "../../reduxV2/broker/broker.actions";
import * as brokerApi2 from "../../reduxV2/broker/broker.api";
import { EAssetType } from "../../types/asset.types";
import { showAlert } from "../../utils/alert/alert.utils";
import { isURL } from "../../utils/document.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { getCreateSaga } from "../generic/create.saga";
import { getDeleteSaga } from "../generic/delete.saga";
import { getGetDetailSaga } from "../generic/detail.saga";
import { getGetPagedSaga } from "../generic/paged.saga";
import { takeLatestWithUniquePayload } from "../utils/saga.utils";
import * as brokerActions from "./broker.actions";
import * as brokerApi from "./broker.api";
import CONFIG from "./broker.config";
function uploadDocument(attachment) {
    var file, preSignedUrl, metaData;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                file = {
                    // @ts-ignore
                    name: attachment.name,
                    // @ts-ignore
                    path: (_a = attachment.file) === null || _a === void 0 ? void 0 : _a.path,
                    // @ts-ignore
                    type: (_b = attachment.file) === null || _b === void 0 ? void 0 : _b.mime,
                };
                return [4 /*yield*/, call(assetApi.uploadDocumentToS3, Platform.OS === "web" ? attachment : file)];
            case 1:
                preSignedUrl = _c.sent();
                metaData = {
                    name: "".concat(attachment.name),
                    type: EAssetType.Splash,
                };
                return [4 /*yield*/, call(assetApi.uploadDocument, preSignedUrl, metaData)];
            case 2: 
            // @ts-ignore
            return [2 /*return*/, _c.sent()];
        }
    });
}
function getAllEmployeesStartFlow(action) {
    var payload, result, unknownError_1, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = action.payload;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(brokerApi.getAllEmployees, payload.id)];
            case 2:
                result = _a.sent();
                return [4 /*yield*/, put(brokerActions.getAllEmployees.actions.success({ employees: result.data }))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                unknownError_1 = _a.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                return [4 /*yield*/, put(brokerActions.getAllEmployees.actions.failure({ error: error }))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function brokerUpdateStartFlow(action) {
    var _a, id, data, logo, onSuccess, payload, hasNewLogo, newLogo, response, unknownError_2, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, id = _a.id, data = _a.data, logo = _a.logo, onSuccess = _a.onSuccess;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 8, , 10]);
                payload = __assign({}, data);
                hasNewLogo = (logo && !isURL(logo)) || false;
                if (!logo) {
                    payload.splashUrl = null;
                    payload.splashAsset = null;
                }
                if (!hasNewLogo) return [3 /*break*/, 3];
                return [4 /*yield*/, uploadDocument(logo)];
            case 2:
                newLogo = _b.sent();
                payload.splashUrl = newLogo === null || newLogo === void 0 ? void 0 : newLogo.url;
                payload.splashAsset = newLogo === null || newLogo === void 0 ? void 0 : newLogo.name;
                _b.label = 3;
            case 3: return [4 /*yield*/, call(brokerApi.update, {
                    id: id,
                    data: payload,
                })];
            case 4:
                _b.sent();
                return [4 /*yield*/, call(brokerApi2.getDetail, {
                        id: id,
                    })];
            case 5:
                response = _b.sent();
                return [4 /*yield*/, put(brokerActionsV2.getDetailSucceeded.getAction({ id: id, result: response }))];
            case 6:
                _b.sent();
                return [4 /*yield*/, put(brokerActions.update.actions.success({ data: response.data }))];
            case 7:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response.data);
                showAlert({
                    type: "success",
                    message: getLocalizedText("backoffice.broker_edit.success.message"),
                });
                return [3 /*break*/, 10];
            case 8:
                unknownError_2 = _b.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                showAlert({
                    type: "error",
                    message: error.message,
                });
                return [4 /*yield*/, put(brokerActions.getAllEmployees.actions.failure({ error: error }))];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatestWithUniquePayload(function (_a) {
                    var payload = _a.payload;
                    return payload.id;
                }, brokerActions.getDetail.types.START, getGetDetailSaga({
                    entityName: CONFIG.ENTITY_NAME,
                    getDetail: brokerApi.getDetail,
                }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(brokerActions.getPaged.types.START, getGetPagedSaga({
                        entityName: CONFIG.ENTITY_NAME,
                        getPaged: brokerApi.getPaged,
                    }))];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(brokerActions.deleteObject.types.START, getDeleteSaga({
                        entityName: CONFIG.ENTITY_NAME,
                        deleteObject: brokerApi.deleteObject,
                    }))];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(brokerActions.create.types.START, getCreateSaga({
                        entityName: CONFIG.ENTITY_NAME,
                        create: brokerApi.create,
                        getDetail: brokerApi.getDetail,
                    }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest(brokerActions.update.types.START, brokerUpdateStartFlow)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeLatest(brokerActions.getAllEmployees.types.START, getAllEmployeesStartFlow)];
            case 6:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// eslint-disable-next-line import/no-default-export
export default saga;
